<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink" :readonly="readonly"
      @focus="onFocus" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" name="abc" :title="title" />
  </div>
</template>

<script>
  export default {
    name: 'SexSelect',
    props: {
      label: {
        type: String,
        default: '未定义'
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      title: {
        type: String,
        default: '请选择'
      },
      value: {
        default: ''
      }
    },
    data() {
      return {
        form: {
          token: ''
        },
        selectValue: this.value,
        isLink: true,
        readonly: true,
        show: false,
        actions: [{
          name: '男',
          id: 1
        }, {
          name: '女',
          id: 0
        }],
        token: '',
        companyid: ''
      }
    },
    watch: {
      value(newVal) {
        this.selectValue = newVal
      }
    },
    methods: {
      onFocus: function() {
        this.show = true
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false
        this.selectValue = item.name
        this.$emit('input', this.selectValue)
        this.$emit('update:selectkey', item.id)
      }   
    },
    mounted: function() {
    }
  }
</script>

<style>
</style>
